import ChristmasModal from 'themes/cvb/components/content/ChristmasModal'
import LayoutBase from 'themes/base/components/shop/LayoutBase'
import SeoMixin from '~/sites/cvb/mixins/SeoMixin'

export default {
  mixins: [SeoMixin],
  extends: LayoutBase,
  components: {
    ChristmasModal,
  },
  head() {
    const baseHead = this.getSeoHead ? this.getSeoHead() : {}
    const baseHeadAttrs = { ...baseHead }
    delete baseHeadAttrs.title
    delete baseHeadAttrs.meta
    delete baseHeadAttrs.link
    delete baseHeadAttrs.changed

    const homepageUrl = this.makeAbsoluteUrl('/')
    const siteName = this.getSeoShortTitle ? this.getSeoShortTitle() : ''

    const organizationJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: siteName,
      url: homepageUrl,
      logo: this.getStructuredLogoUrl(),
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: this.$store.state.globals.contact.phone,
        email: this.$store.state.globals.contact.email,
        contactType: 'customer support',
        availableLanguage: ['cs'],
      },
    }

    const contact = this.$store.state.globals.contact

    if (contact) {
      organizationJsonLd.contactPoint = {
        '@type': 'ContactPoint',
        telephone: contact.phone ? contact.phone.replace(/ /g, '') : undefined,
        email: contact.email,
        contactType: 'customer support',
        availableLanguage: ['cs'],
      }
    }

    const websiteJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      url: homepageUrl,
      name: siteName,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${homepageUrl}hledat?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    }

    const extraScripts = [
      {
        hid: 'ld-json-organization',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(organizationJsonLd),
      },
      {
        hid: 'ld-json-website',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(websiteJsonLd),
      },
    ]

    const existingScripts = baseHead.script || []
    const existingSanitizers = baseHead.__dangerouslyDisableSanitizers || []
    const sanitizers = existingSanitizers.includes('script') ? existingSanitizers : [...existingSanitizers, 'script']

    return {
      ...baseHeadAttrs,
      script: [...existingScripts, ...extraScripts],
      __dangerouslyDisableSanitizers: sanitizers,
    }
  },
}
